<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Reporte: Tabular de Encuesta PROMOTORIA PM</v-toolbar-title>
          <v-spacer></v-spacer>
          <download-csv v-show="false" ref="export" :data="export_data" name="reporte_tabular_encuesta.csv"></download-csv>
          <v-btn text small :disabled="!export_data.length || loading" @click="exportData()">
            Exportar
            <v-icon right>mdi-arrow-down</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogFilters = true">
            Filtros
            <v-icon right>mdi-filter</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" :loading="loading" :search="search" fixed-header height="550px"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="-1" item-key="id" class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogFilters" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Filtros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="clearFilters()">
              Reiniciar
              <v-icon right>mdi-minus</v-icon>
            </v-btn>
            <v-btn text small :disabled="loading" @click="closeFilters()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="setFilters()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.encuesta" :items="encuestas" item-value="id" item-text="nombre" label="Encuesta" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <span>Fecha de registro</span>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog ref="startDateUpd" v-model="dialogStartDateUpd" :return-value.sync="filters.fecha_inicio_act" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="filters.fecha_inicio_act" label="Fecha inicio" :disabled="loading" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.fecha_inicio_act" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogStartDateUpd = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.startDateUpd.save(filters.fecha_inicio_act)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog ref="endDateUpd" v-model="dialogEndDateUpd" :return-value.sync="filters.fecha_fin_act" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="filters.fecha_fin_act" label="Fecha fin" :disabled="loading" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.fecha_fin_act" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogEndDateUpd = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.endDateUpd.save(filters.fecha_fin_act)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12">
                  <v-switch v-model="show_url" label="Mostrar URL de las fotos" :disabled="loading"></v-switch>
                </v-col>
                <v-col cols="12">
                  <v-switch v-model="export_direct" label="Exportar información de manera directa (No se muestran resultados)" :disabled="loading"></v-switch>
                </v-col>
                <v-col cols="12">
                  <v-switch v-model="show_pipes" label="Utilizar pipes ( | ) como delimitador en la descarga del reporte" :disabled="loading"></v-switch>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import Vue from 'vue'
import services from '@/utils/services'
import moment from 'moment'
import jsoncsv from 'vue-json-csv'
import download from 'downloadjs'

Vue.component('download-csv', jsoncsv)

export default {
  name: 'tabularencuestapromopm',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    search: '',
    headers: [],
    headers_default: [
      { text: 'Folio', align: 'center', sortable: false, width: '100%', value: 'folio' },
      { text: 'Cadena comercial', align: 'center', sortable: false, width: '100%', value: 'cadena_comercial' },
      { text: 'Plaza', align: 'center', sortable: false, width: '100%', value: 'plaza' },
      { text: 'Determinante', align: 'center', sortable: false, width: '100%', value: 'determinante' },
      { text: 'Tienda', align: 'center', sortable: false, width: '100%', value: 'tienda' },
      { text: 'Fecha programada', align: 'center', sortable: false, width: '100%', value: 'fecha_programada' },
      { text: 'Fecha visita', align: 'center', sortable: false, width: '100%', value: 'fecha_visita' },
      { text: 'No. Cliente', align: 'center', sortable: false, width: '100%', value: 'numero_cliente' },
      { text: 'TERRITORIO', align: 'center', sortable: false, width: '100%', value: 'territorio' },
      { text: 'Gerencia', align: 'center', sortable: false, width: '100%', value: 'gerencia' },
      { text: 'Aplicada por', align: 'center', sortable: false, width: '100%', value: 'aplicada_por' },
      { text: 'Inicio', align: 'center', sortable: false, width: '100%', value: 'inicio' },
      { text: 'Fin', align: 'center', sortable: false, width: '100%', value: 'fin' },
      { text: 'Código tienda', align: 'center', sortable: false, width: '100%', value: 'codigo_tienda' },
      { text: 'HEETS', align: 'center', sortable: false, width: '100%', value: 'heets' },
      { text: 'Subdirección', align: 'center', sortable: false, width: '100%', value: 'subdireccion' },
      { text: 'Res. Latitud', align: 'center', sortable: false, width: '100%', value: 'res_latitud' },
      { text: 'Res. Longitud', align: 'center', sortable: false, width: '100%', value: 'res_longitud' },
      { text: 'Tie. Latitud', align: 'center', sortable: false, width: '100%', value: 'tie_latitud' },
      { text: 'Tie. Longitud', align: 'center', sortable: false, width: '100%', value: 'tie_longitud' },
      { text: '¿Pudiste realizar la actividad en tienda?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Pudiste realizar la actividad en tienda?' },
      { text: '¿Por qué no te permitió el empleado?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Por qué no te permitió el empleado?' },
      { text: 'Al llegar a la tienda ¿Encontraste el mueble limpio?', align: 'center', sortable: false, width: '100%', value: 'respuesta_Al llegar a la tienda ¿Encontraste el mueble limpio?' },
      { text: 'Al llegar a la tienda ¿Encontraste planograma correcto?', align: 'center', sortable: false, width: '100%', value: 'respuesta_Al llegar a la tienda ¿Encontraste planograma correcto?' },
      { text: 'Al llegar a la tienda ¿Encontraste todos los precios?', align: 'center', sortable: false, width: '100%', value: 'respuesta_Al llegar a la tienda ¿Encontraste todos los precios?' },
      { text: 'Al llegar a la tienda ¿Encontraste PEPS ejecutados?', align: 'center', sortable: false, width: '100%', value: 'respuesta_Al llegar a la tienda ¿Encontraste PEPS ejecutados?' },
      { text: 'Al llegar al PDV ¿Encontraste Huecos?', align: 'center', sortable: false, width: '100%', value: 'respuesta_Al llegar al PDV ¿Encontraste Huecos?' },
      { text: '¿Cuántos huecos encontraste en planograma al llegar?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Cuántos huecos encontraste en planograma al llegar?' },
      { text: 'Motivo de los huecos que encontraste al llegar (selecciona las que apliquen)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Motivo de los huecos que encontraste al llegar (selecciona las que apliquen)' },
      { text: '¿Qué variantes encontraste en DESABASTO?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Qué variantes encontraste en DESABASTO?' },
      { text: '¿Realizaste planograma vigente?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Realizaste planograma vigente?' },
      { text: 'Otra (planograma)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Otra (planograma)' },
      { text: '¿RELLENASTE el exhibidor conforme a planograma?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿RELLENASTE el exhibidor conforme a planograma?' },
      { text: 'Otra (rellenaste exhibidor)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Otra (rellenaste exhibidor)' },
      { text: '¿Encontraste charola amarilla promocional?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Encontraste charola amarilla promocional?' },
      { text: '¿Encontraste Huecos en charola Amarilla?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Encontraste Huecos en charola Amarilla?' },
      { text: '¿Cuántos huecos encontraste en charola amarilla?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Cuántos huecos encontraste en charola amarilla?' },
      { text: '¿Implementaste CHAROLA PROMOCIONAL (amarilla) con marcas vigentes?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Implementaste CHAROLA PROMOCIONAL (amarilla) con marcas vigentes?' },
      { text: 'Especifica (charola amarilla)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Especifica (charola amarilla)' },
      { text: '¿Diste mantenimiento a Counter Display Negro?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Diste mantenimiento a Counter Display Negro?' },
      { text: 'Especifica (counter display)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Especifica (counter display)' },
      { text: '¿Encontraste charola HEETS?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Encontraste charola HEETS?' },
      { text: '¿Encontraste Huecos en charola HEETS?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Encontraste Huecos en charola HEETS?' },
      { text: '¿Cuántos huecos encontraste en charola HEETS?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Cuántos huecos encontraste en charola HEETS?' },
      { text: '¿Diste mantenimiento a CHAROLA PROMOCIONAL HEETS ?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Diste mantenimiento a CHAROLA PROMOCIONAL HEETS ?' },
      { text: 'Especifica (charola Heets)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Especifica (charola Heets)' },
      { text: '(Tiendas sin charola) ¿Colocaste las cajetillas HEETS de manera vertical en la charola principal?', align: 'center', sortable: false, width: '100%', value: 'respuesta_(Tiendas sin charola) ¿Colocaste las cajetillas HEETS de manera vertical en la charola principal?' },
      { text: 'Especifica (charola principal)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Especifica (charola principal)' },
      { text: '¿Aseguraste PRECIOS en TODOS los frentes?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Aseguraste PRECIOS en TODOS los frentes?' },
      { text: '¿Diste mantenimiento a cabecera?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Diste mantenimiento a cabecera?' },
      { text: '¿Diste mantenimiento a cabecera HEETS?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Diste mantenimiento a cabecera HEETS?' },
      { text: 'Otra (cabecera)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Otra (cabecera)' },
      { text: '¿Cuántos huecos Encontraste en cabecera ?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Cuántos huecos Encontraste en cabecera ?' },
      { text: '¿Aseguraste precios en cabecera?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Aseguraste precios en cabecera?' },
      { text: '¿Diste mantenimiento a Torre Lateral?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Diste mantenimiento a Torre Lateral?' },
      { text: 'Especifica (torre lateral)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Especifica (torre lateral)' },
      { text: '¿Encontraste Counter Display HEETS?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Encontraste Counter Display HEETS?' },
      { text: '¿Encontraste Huecos en Counter display HEETS?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Encontraste Huecos en Counter display HEETS?' },
      { text: '¿Diste mantenimiento a Counter Display HEETS?', align: 'center', sortable: false, width: '100%', value: 'respuesta_¿Diste mantenimiento a Counter Display HEETS?' },
      { text: 'Especifica (counter HEETS)', align: 'center', sortable: false, width: '100%', value: 'respuesta_Especifica (counter HEETS)' }
    ],
    items: [],
    resultados: [],
    encuestas: [],
    usuarios: [],
    plazas: [],
    url_spaces: '',
    url_public: '',
    csv: '',
    show_url: false,
    show_pipes: false,
    export_direct: false,
    export_data: [],
    filters: {
      encuesta: '',
      fecha_inicio_act: '',
      fecha_fin_act: ''
    },
    dialogFilters: false,
    dialogStartDate: false,
    dialogEndDate: false,
    dialogStartDateUpd: false,
    dialogEndDateUpd: false
  }),
  mounted() {
    this.refresh()
    this.dialogFilters = true
  },
  methods: {
    refresh() {
      this.loading = true
      let data = {
        filtros: JSON.stringify(this.filters)
      }
      services.ws('get', 'tabularEncuestaPROMOPM', data)
        .then(res => {
          if (res.ok) {
            this.resultados = res.data.resultados
            this.encuestas = res.data.encuestas
            this.usuarios = res.data.usuarios
            this.plazas = res.data.plazas
            this.url_spaces = res.data.url_spaces
            this.url_public = res.data.url_public
            for (let i = 0; i < this.resultados.length; i++) {
              this.resultados[i]['res_latitud'] = this.resultados[i].res_coordenadas.split(',')[0]
              this.resultados[i]['res_longitud'] = this.resultados[i].res_coordenadas.split(',')[1]
            }
            this.prepareHeaders()
            this.prepareExportData()
            this.items = this.resultados
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearFilters() {
      for (let key in this.filters) {
        this.filters[key] = ''
      }
    },
    closeFilters() {
      this.dialogFilters = false
    },
    setFilters() {
      if (this.filters.encuesta !== '') {
        if (this.filters.fecha_inicio_act === '' || this.filters.fecha_fin_act === '') {
          this.error = true
          this.msgError = 'Debe establecer el filtro de fechas (Fecha de registro)'
        }
        else if (moment(this.filters.fecha_fin_act, 'YYYY-MM-DD').diff(moment(this.filters.fecha_inicio_act, 'YYYY-MM-DD')) < 0) {
          this.error = true
          this.msgError = 'La fecha fin debe ser mayor o igual que la fecha inicio (Fecha de registro)'
        }
        else {
          this.loading = true
          let data = {
            filtros: JSON.stringify(this.filters),
            show_url: this.show_url,
            show_pipes: this.show_pipes
          }
          services.ws('get', 'tabularEncuestaPROMOPM', data)
            .then(res => {
              if (res.ok) {
                this.csv = res.data.csv
                if (!this.export_direct) {
                  this.headers = res.data.headers
                  this.resultados = res.data.resultados
                  this.encuestas = res.data.encuestas
                  this.usuarios = res.data.usuarios
                  this.plazas = res.data.plazas
                  this.url_spaces = res.data.url_spaces
                  this.url_public = res.data.url_public
                  this.items = this.resultados
                }
                else {
                  if (this.show_pipes) {
                    download(this.csv, "reporte_tabular_encuesta.txt", "text/plain");
                  }
                  else {
                    download(this.csv, "reporte_tabular_encuesta.csv", "text/csv");
                  }
                }
                this.closeFilters()
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe establecer el filtro de encuesta'
      }
    },
    prepareHeaders() {
      this.headers = this.headers_default.slice()
      if (this.resultados.length) {
        let col = {
          text: 'Enlace de fotos',
          align: 'center',
          sortable: false,
          width: '100%',
          value: 'enlace_fotos'
        }
        this.headers.push(col)
      }
      for (let i = 0; i < this.resultados.length; i++) {
        for (let j = 0; j < this.resultados[i].respuestas.length; j++) {
          let id = this.resultados[i].respuestas[j].nombre
          if (!('respuesta_' + id in this.resultados[i])) {
            this.resultados[i]['respuesta_' + id] = ''
          }
          if (this.resultados[i].respuestas[j].tipo !== 'foto') {
            if ('respuesta' in this.resultados[i].respuestas[j] && this.resultados[i].respuestas[j].respuesta !== null && this.resultados[i].respuestas[j].respuesta !== '') {
              this.resultados[i]['respuesta_' + id] = (this.resultados[i]['respuesta_' + id] === '') ?
                                                       this.resultados[i].respuestas[j].respuesta :
                                                       this.resultados[i]['respuesta_' + id] + ' ' + this.resultados[i].respuestas[j].respuesta
            }
          }
          else {
            let foto = (this.show_url && ('respuesta' in this.resultados[i].respuestas[j]) &&
                        this.resultados[i].respuestas[j].respuesta !== null) ?
                        this.url_spaces + '/' + this.resultados[i].respuestas[j].respuesta.replace(/_/g, '/') : ''
            this.resultados[i]['respuesta_' + id] = (this.resultados[i]['respuesta_' + id] === '') ? foto :
                                                     this.resultados[i]['respuesta_' + id] + ' ' + foto
          }
        }
        this.resultados[i]['enlace_fotos'] = this.url_public + '?id=' + this.resultados[i].resultado
      }
    },
    prepareExportData() {
      this.export_data = []
      for (let i = 0; i < this.resultados.length; i++) {
        let row = {}
        let tmp = {}
        for (let j = 0; j < this.headers.length; j++) {
          if (this.headers[j].text in tmp) {
            tmp[this.headers[j].text] += 1
            let idx = tmp[this.headers[j].text]
            row[this.headers[j].text + ' (' + idx + ')'] = this.resultados[i][this.headers[j].value]
          }
          else {
            tmp[this.headers[j].text] = 0
            row[this.headers[j].text] = this.resultados[i][this.headers[j].value]
          }
        }
        this.export_data.push(row)
      }
    },
    exportData() {
      if (this.show_pipes) {
        download(this.csv, "reporte_tabular_encuesta.txt", "text/plain");
      }
      else {
        download(this.csv, "reporte_tabular_encuesta.csv", "text/csv");
      }
      //this.$refs.export.$el.click()
    }
  }
}
</script>

<style>
  td, th > span {
    white-space: nowrap;
  }
</style>
